import React from "react";
import CategoryCard from "./CategoryCard";

const CategoryGridCard = ({ 
    variant = 'it-support',
    categoryData = [],
}) => {

    const categories = categoryData?.filter(cat => cat.value !== 'all');

    return (
        <div className="flex-1 outline-none space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {categories?.map((category) => (
                    <div key={category?.value} className="opacity-100 transform-none">
                        <CategoryCard 
                            variant={variant}
                            category={category} 
                        />
                    </div>
                ))}
            </div>
        </div>
    )
};

export default CategoryGridCard;